export const REMIX_PASTE_MENU_KEY = 'ai-paste-menu-remix';
